import { render, staticRenderFns } from "./home.vue?vue&type=template&id=7c66a6a2&"
import script from "./home.vue?vue&type=script&lang=ts&"
export * from "./home.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c66a6a2')) {
      api.createRecord('7c66a6a2', component.options)
    } else {
      api.reload('7c66a6a2', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=7c66a6a2&", function () {
      api.rerender('7c66a6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/home.vue"
export default component.exports